<template lang="pug">
.column(:class="classes")
  slot
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Gutters = 'none' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'

const props = withDefaults(defineProps<{
  width?: string | number | null
  desktop?: string | null
  tablet?: string | null
  mobile?: string | null
  noGutter?: boolean
  gutters?: Gutters
}>(), {
  width    : null,
  desktop  : null,
  tablet   : null,
  mobile   : null,
  noGutter : false,
})

const classes = computed(() => {
  const retval: string[] = []
  if (props.noGutter) {
    retval.push('no-gutter')
  }

  const desktop = props.desktop || props.width || props.tablet || props.mobile
  if (desktop) {
    retval.push(`cd-${desktop}`)
  }

  if (props.tablet || props.mobile) {
    retval.push(`ct-${props.tablet || props.mobile}`)
  }

  retval.push(`cm-${props.mobile || 12}`)

  return retval.join(' ')
})
</script>

<style lang="scss">
$col-1: 8.33%; // 100 / 12

.cd-1 {width: 8.33%;}
.cd-2 {width: 16.66%;}
.cd-3 {width: 25%;}
.cd-4 {width: 33.33%;}
.cd-5 {width: 41.66%;}
.cd-6 {width: 50%;}
.cd-7 {width: 58.33%;}
.cd-8 {width: 66.66%;}
.cd-9 {width: 75%;}
.cd-10 {width: 83.33%;}
.cd-11 {width: 91.66%;}
.cd-12 {width: 100%;}

@include not-desktop(){
  .ct-1 {width: 8.33%;}
  .ct-2 {width: 16.66%;}
  .ct-3 {width: 25%;}
  .ct-4 {width: 33.33%;}
  .ct-5 {width: 41.66%;}
  .ct-6 {width: 50%;}
  .ct-7 {width: 58.33%;}
  .ct-8 {width: 66.66%;}
  .ct-9 {width: 75%;}
  .ct-10 {width: 83.33%;}
  .ct-11 {width: 91.66%;}
  .ct-12 {width: 100%;}
}

@include mobile(){
  .cm-1 {width: 8.33%;}
  .cm-2 {width: 16.66%;}
  .cm-3 {width: 25%;}
  .cm-4 {width: 33.33%;}
  .cm-5 {width: 41.66%;}
  .cm-6 {width: 50%;}
  .cm-7 {width: 58.33%;}
  .cm-8 {width: 66.66%;}
  .cm-9 {width: 75%;}
  .cm-10 {width: 83.33%;}
  .cm-11 {width: 91.66%;}
  .cm-12 {width: 100%;}
}

.column {
  padding: 0 $space-xxs $space-s;
  margin: 0;

  &.no-gutter {
    padding-bottom: 0;
  }
}

.drawer-body{
  .ct-12 {width: 100%;}
}

</style>
